import { FormField } from "generated/graphql";

export function FormFieldName({ formField, compactMode }: { formField: FormField; compactMode?: boolean }) {
  return (
    <p className={compactMode ? "" : "text-xl"} data-pendo={`${formField.id}-name`}>
      {formField.outlinePrefix || ""} {formField.name}
      {formField.required && "*"}
    </p>
  );
}
